(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false;

  if (prefersReducedMotion) {
    var all = document.querySelectorAll('.phase-reveal');
    for (var i = 0; i < all.length; i++) {
      all[i].classList.add('is-visible');
    }
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );

  function initReveal() {
    var elements = document.querySelectorAll('.phase-reveal');
    elements.forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }

  document.addEventListener('shopify:section:load', function () {
    var newElements = document.querySelectorAll('.phase-reveal:not(.is-visible)');
    newElements.forEach(function (el) { observer.observe(el); });
  });
})();